import {
  Component, OnInit, OnDestroy
} from '@angular/core';

import {
  BehaviorSubject, takeUntil, tap
} from 'rxjs';

import {
  IBasicFormItem, IBasicFormOptions, ResponseUpdateItem, StepItemConfig
} from '@sondermind/utilities/models-flows';

import { StepComponent } from '../step.component';

export interface IChipsConfig extends StepItemConfig {
  form: IBasicFormItem[];
}

@Component({
  selector: 'flows-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  standalone: false
})
export class ChipsComponent extends StepComponent<IChipsConfig> implements OnInit, OnDestroy {
  options$ = new BehaviorSubject<IBasicFormOptions[]>([]);
  selectedOption: IBasicFormOptions = null;
  formItem: IBasicFormItem;
  label: string;

  ngOnInit(): void {
    this.valid.next(true);

    [this.formItem] = this.config.form;
    this.label = this.formItem.label;

    if (this.formItem.type === 'chipgroup'){
      this.initOptionsFromForm();
    }

    this.setSelectedItem();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }

  initOptionsFromForm(): void {
    this.options$.next(
      [
        ...this.formItem.options ?? [],
        ...this.wizard?.context?.options ?? []
      ].filter((formOptions, index, self) => index === self.findIndex((val) => val.value === formOptions.value))
    );
  }

  setSelectedItem(): void {
    this.options$.pipe(
      takeUntil(this.destroyed$),
      tap((options) => {
        this.selectedOption = options.find((x) => x.value === this.data[this.formItem?.name]);
      })
    ).subscribe();
  }

  handleSingleOptionClick(value: IBasicFormOptions): void {
    this.selectedOption = value;
    this.valid.next(true);
    this.submit.emit();
  }

  handleChipKeydown(event: KeyboardEvent, option: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      // Prevent default behavior (e.g., page scrolling for Space key)
      event.preventDefault();
      this.handleSingleOptionClick(option);
    }
  }

  onSubmit(): ResponseUpdateItem[] {
    return [
      <ResponseUpdateItem>{
        human: this.formItem.label,
        key: this.formItem.name,
        value: this.selectedOption?.value
      }
    ];
  }
}
